import {formatName,convertDateTimeFormatToDate} from "../../utils";

// Outside agents show their brokerage when the property records one, the
// agent's own name otherwise; formatName can return null, never let it print.
function outsideAgentLabel(firmName, agentName) {
    const firm = (firmName || '').trim();
    if (firm) return firm;
    return ((agentName || '') + '').trim();
}

export class FeesPipeline {
    id;
    no;
    closeOfEscrow;
    name;
    transactionType;
    city;
    state;
    totalFee;
    listingAgent1;
    listingAgent1Percent;
    listingAgent1Price;
    listingAgent2;
    listingAgent2Percent;
    listingAgent2Price;
    listingAgent3;
    listingAgent3Percent;
    listingAgent3Price;
    listingAgent4;
    listingAgent4Percent;
    listingAgent4Price;
    buyerAgent1;
    buyerAgent1Percent;
    buyerAgent1Price;
    buyerAgent2;
    buyerAgent2Percent;
    buyerAgent2Price;
    buyerAgent3;
    buyerAgent3Percent;
    buyerAgent3Price;
    buyerAgent4;
    buyerAgent4Percent;
    buyerAgent4Price;
    striveFee;
    agentFee;

    constructor(data, index, total = false, agentIds = [], avarage = false, side = 'ALL') {
        this.id = data.ARCIMEDES_ROW_ID ? data.ARCIMEDES_ROW_ID : '';
        this.no = index || '';
        this.closeOfEscrow = data.CLOSE_OF_ESCROW ? convertDateTimeFormatToDate(data.CLOSE_OF_ESCROW) : '';
        this.name = data.NAME ? data.NAME : '';
        this.transactionType = data.TRANSACTION_TYPE ? data.TRANSACTION_TYPE : '';
        this.city = data.CITY ? data.CITY : '';
        this.state = data.STATE ? data.STATE : '';
        this.totalFee = data.TOTAL_FEE ? parseFloat(data.TOTAL_FEE) : data.REFERRAL_FEE;
        this.listingAgent1 = formatName(data, 'LISTING_AGENT_1_');
        this.listingAgent1Percent = data.LISTING_AGENT_1_PERCENT ? parseFloat(data.LISTING_AGENT_1_PERCENT) : 0;
        this.listingAgent1Price = this.totalFee && this.listingAgent1Percent ? this.totalFee * this.listingAgent1Percent / 100 : 0;
        this.listingAgent2 = formatName(data, 'LISTING_AGENT_2_');
        this.listingAgent2Percent = data.LISTING_AGENT_2_PERCENT ? parseFloat(data.LISTING_AGENT_2_PERCENT) : 0;
        this.listingAgent2Price = this.totalFee && this.listingAgent2Percent ? this.totalFee * this.listingAgent2Percent / 100 : 0;
        this.listingAgent3 = formatName(data, 'LISTING_AGENT_3_');
        this.listingAgent3Percent = data.LISTING_AGENT_3_PERCENT ? parseFloat(data.LISTING_AGENT_3_PERCENT) : 0;
        this.listingAgent3Price = this.totalFee && this.listingAgent3Percent ? this.totalFee * this.listingAgent3Percent / 100 : 0;
        this.listingAgent4 = outsideAgentLabel(data.LISTING_AGENT_4_FIRM_NAME, formatName(data, 'LISTING_AGENT_4_'));
        this.listingAgent4Percent = data.LISTING_AGENT_4_PERCENT ? parseFloat(data.LISTING_AGENT_4_PERCENT) : 0;
        this.listingAgent4Price = this.totalFee && this.listingAgent4Percent ? this.totalFee * this.listingAgent4Percent / 100 : 0;
        this.buyerAgent1 = formatName(data, 'BUYER_AGENT_1_');
        this.buyerAgent1Percent = data.BUYER_AGENT_1_PERCENT ? parseFloat(data.BUYER_AGENT_1_PERCENT) : 0;
        this.buyerAgent1Price = this.totalFee && this.buyerAgent1Percent ? this.totalFee * this.buyerAgent1Percent / 100 : 0;
        this.buyerAgent2 = formatName(data, 'BUYER_AGENT_2_');
        this.buyerAgent2Percent = data.BUYER_AGENT_2_PERCENT ? parseFloat(data.BUYER_AGENT_2_PERCENT) : 0;
        this.buyerAgent2Price = this.totalFee && this.buyerAgent2Percent ? this.totalFee * this.buyerAgent2Percent / 100 : 0;
        this.buyerAgent3 = formatName(data, 'BUYER_AGENT_3_');
        this.buyerAgent3Percent = data.BUYER_AGENT_3_PERCENT ? parseFloat(data.BUYER_AGENT_3_PERCENT) : 0;
        this.buyerAgent3Price = this.totalFee && this.buyerAgent3Percent ? this.totalFee * this.buyerAgent3Percent / 100 : 0;
        this.buyerAgent4 = outsideAgentLabel(data.BUYER_AGENT_4_FIRM_NAME, formatName(data, 'BUYER_AGENT_4_'));
        this.buyerAgent4Percent = data.BUYER_AGENT_4_PERCENT ? parseFloat(data.BUYER_AGENT_4_PERCENT) : 0;
        this.buyerAgent4Price = this.totalFee && this.buyerAgent4Percent ? this.totalFee * this.buyerAgent4Percent / 100 : 0;
        // Attribute by the slot's stable agent id, never by name: a name match
        // credits any same-named agent (and slot 4 labels are firm names).
        // Slots 1-3 only — slot 4 is the outside AGENTS id space, which the
        // agent filter also never matches. The side selection restricts the
        // slots the same way the query's agent filter did. The ids stay on
        // the row so the footer's per-slot totals can test occupancy too.
        this.listingAgent1Id = data.LISTING_AGENT_1_ID != null ? String(data.LISTING_AGENT_1_ID) : '';
        this.listingAgent2Id = data.LISTING_AGENT_2_ID != null ? String(data.LISTING_AGENT_2_ID) : '';
        this.listingAgent3Id = data.LISTING_AGENT_3_ID != null ? String(data.LISTING_AGENT_3_ID) : '';
        this.buyerAgent1Id = data.BUYER_AGENT_1_ID != null ? String(data.BUYER_AGENT_1_ID) : '';
        this.buyerAgent2Id = data.BUYER_AGENT_2_ID != null ? String(data.BUYER_AGENT_2_ID) : '';
        this.buyerAgent3Id = data.BUYER_AGENT_3_ID != null ? String(data.BUYER_AGENT_3_ID) : '';
        const selectedIds = (Array.isArray(agentIds) ? agentIds : []).map(String).filter(Boolean);
        const listingSlots = [
            [this.listingAgent1Id, this.listingAgent1Price],
            [this.listingAgent2Id, this.listingAgent2Price],
            [this.listingAgent3Id, this.listingAgent3Price],
        ];
        const buyerSlots = [
            [this.buyerAgent1Id, this.buyerAgent1Price],
            [this.buyerAgent2Id, this.buyerAgent2Price],
            [this.buyerAgent3Id, this.buyerAgent3Price],
        ];
        const attributableSlots = side === 'LISTING_AGENT_4_FIRM' ? listingSlots
            : side === 'BUYER_AGENT_4_FIRM' ? buyerSlots
                : listingSlots.concat(buyerSlots);
        this.agentFee = 0;
        if (selectedIds.length) {
            attributableSlots.forEach(([slotId, price]) => {
                if (slotId && selectedIds.includes(slotId) && price) {
                    this.agentFee += price;
                }
            });
        }

        if (total) this.striveFee = data.STRIVE_FEE;
        // With an agent filter the fee column reports the selected agents'
        // own portion, so co-agents' splits on shared deals never enter the
        // totals. Referral rows work through the same percents: the data
        // stamps 100% on the referring agent's slot.
        else if (selectedIds.length) this.striveFee = this.agentFee;
        else this.striveFee = data.TRANSACTION_TYPE === 'Referral' ?
        data.REFERRAL_FEE : this.listingAgent1Price + this.listingAgent2Price + this.listingAgent3Price + this.buyerAgent1Price + this.buyerAgent2Price + this.buyerAgent3Price;
        if (total) {
            this.agentFee = data.AGENT_FEE;
            this.buyerAgent1Price = data.BUYER_AGENT1_TOTAL_FEE;
            this.buyerAgent2Price = data.BUYER_AGENT2_TOTAL_FEE;
            this.buyerAgent3Price = data.BUYER_AGENT3_TOTAL_FEE;
            this.buyerAgent4Price = data.BUYER_AGENT4_TOTAL_FEE;
            this.listingAgent1Price = data.LISTING_AGENT1_TOTAL_FEE;
            this.listingAgent2Price = data.LISTING_AGENT2_TOTAL_FEE;
            this.listingAgent3Price = data.LISTING_AGENT3_TOTAL_FEE;
            this.listingAgent4Price = data.LISTING_AGENT4_TOTAL_FEE;
        }
        if(avarage && data.hasOwnProperty("STRIVE_FEE")){
            const avg = Number(data.STRIVE_FEE) / data.NO_OF_TRANSACTIONS
            this.striveFee = avg.toFixed(2); // this is for the avarage
        }else if(avarage){
            this.striveFee = data.NO_OF_TRANSACTIONS; // this is for the no of tranactions
        }
    }
}
